export default {
  props: {
    auto: Object,
  },
  watch: {
    auto: {
      immediate: true,
      handler(newVal) {
        this.dataForEdit.sourceId = newVal.id
        this.objectData = newVal
      },
    },
  },
}
